import { Form } from 'antd';
import { Modal } from 'components/ui';
import { ModalContent } from 'horizon/routes/Inspections/InspectionDetail/InspectionDamageIngestion/ModalContent';
import { STEPS } from 'horizon/routes/Inspections/InspectionDetail/InspectionDamageIngestion/ModalContent/common';
import { useState } from 'react';

type MultiInspectionDamageIngestionProps = {
  isOpen: boolean;
  setModalOpen: (open: boolean) => void;
};

export const MultiInspectionDamageIngestion: React.FunctionComponent<
  MultiInspectionDamageIngestionProps
> = ({ isOpen, setModalOpen }) => {
  const [step, setStep] = useState<number>(STEPS.upload);

  const [form] = Form.useForm();

  const handleClose = () => {
    form.resetFields();
    setModalOpen(false);
    setStep(STEPS.upload);
  };

  return (
    <Modal
      title="Upload Damages"
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      destroyOnHidden
    >
      <ModalContent
        form={form}
        step={step}
        setStep={setStep}
        setModalOpen={setModalOpen}
        handleCheckStatus={() => {}}
        onReset={form.resetFields}
        importResult={undefined}
        multiInspection={true}
      />
    </Modal>
  );
};
